// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import PanelAction from '../components-core/panel-action';

export default class MaximizePanelAction extends Component {
    handleClick = event => {
        this.context.togglePanelMaximize();
    };

    render() {
        const props = {
            ...this.props,
            onClick: this.handleClick,
        };

        return <PanelAction {...props} />;
    }
}

MaximizePanelAction.propTypes = {
    hotkey: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    weight: PropTypes.number,
};

MaximizePanelAction.contextTypes = {
    togglePanelMaximize: PropTypes.func.isRequired,
};

MaximizePanelAction.defaultProps = {
    icon: 'window-maximize',
    title: 'Maximize Panel',
    weight: 1000,
};
